import React from 'react';

const Illustration = () => {
  return (
    <div className="illustration w-full">
      <img  src="../../hero.png" alt="" />
    </div>
  );
};

export default Illustration;